type Props = {
  title: string;
  total: number;
  doneCount: number;
};

export function ChatHeader({ title, total, doneCount }: Props) {
  return (
    <header className="shrink-0 bg-white border-b border-slate-200 px-4 py-3 flex items-center justify-between">
      <h1 className="text-sm font-bold text-slate-900">{title}</h1>
      <div className="flex items-center gap-2">
        <div className="flex gap-0.5">
          {Array.from({ length: total }).map((_, i) => (
            <span
              key={i}
              data-role="pdot"
              className={
                "block w-4 h-0.5 rounded " + (i < doneCount ? "bg-indigo-600" : "bg-slate-200")
              }
            />
          ))}
        </div>
        <span className="text-[11px] text-slate-500 font-semibold">
          {doneCount}/{total}
        </span>
      </div>
    </header>
  );
}
